export const BREAKDOWN_PAGE_SIZE = 5;

/**
 * @param {*} $scope
 * @param {*} vm Modal controller instance (controllerAs)
 * @param {string} prefix 'expense' | 'project'
 * @param {function(): Array} getRows
 * @param {string} emptyCountPhrase
 */
export function attachLaborBreakdownTablePaging($scope, vm, prefix, getRows, emptyCountPhrase) {
  const cap = prefix.charAt(0).toUpperCase() + prefix.slice(1);

  function clampPageIndex() {
    const rows = getRows() || [];
    vm[prefix + 'PaginationTotalPages'] = Math.max(1, Math.ceil(rows.length / BREAKDOWN_PAGE_SIZE));
    var idx = vm[prefix + 'PageIndex'];
    if (idx >= vm[prefix + 'PaginationTotalPages']) {
      vm[prefix + 'PageIndex'] = Math.max(0, vm[prefix + 'PaginationTotalPages'] - 1);
    }
  }

  function sortRowsCopy(rows) {
    var col = vm[prefix + 'Sort'].column;
    var desc = vm[prefix + 'Sort'].desc;
    return rows.slice().sort(function(a, b) {
      var cmp;
      if (col === 'cost') {
        cmp = Number(a.cost) - Number(b.cost);
      } else {
        cmp = String(a.name || '')
          .toLowerCase()
          .localeCompare(String(b.name || '').toLowerCase(), undefined, {
            sensitivity: 'base'
          });
      }
      return desc ? -cmp : cmp;
    });
  }

  vm[prefix + 'PageIndex'] = 0;
  vm[prefix + 'Sort'] = { column: 'cost', desc: true };
  vm[prefix + 'TableVisibleRows'] = [];
  vm[prefix + 'PaginationTotalPages'] = 1;

  vm['update' + cap + 'PagedRows'] = function() {
    var raw = getRows() || [];
    clampPageIndex();
    var sorted = sortRowsCopy(raw);
    var start = vm[prefix + 'PageIndex'] * BREAKDOWN_PAGE_SIZE;
    vm[prefix + 'TableVisibleRows'] = sorted.slice(start, start + BREAKDOWN_PAGE_SIZE);
  };

  vm['toggle' + cap + 'Sort'] = function(column) {
    if (!column) {
      return;
    }
    var s = vm[prefix + 'Sort'];
    if (s.column === column) {
      s.desc = !s.desc;
    } else {
      s.column = column;
      s.desc = column === 'cost';
    }
    vm[prefix + 'PageIndex'] = 0;
    vm['update' + cap + 'PagedRows']();
  };

  vm[prefix + 'SortIndicator'] = function(column) {
    if (vm[prefix + 'Sort'].column !== column) {
      return '';
    }
    return vm[prefix + 'Sort'].desc ? ' \u25bc' : ' \u25b2';
  };

  vm[prefix + 'ShowingRangeLabel'] = function() {
    var n = (getRows() || []).length;
    if (n === 0) {
      return emptyCountPhrase;
    }
    var startIdx = vm[prefix + 'PageIndex'] * BREAKDOWN_PAGE_SIZE + 1;
    var endIdx = Math.min(n, (vm[prefix + 'PageIndex'] + 1) * BREAKDOWN_PAGE_SIZE);
    return 'Showing ' + startIdx + '–' + endIdx + ' of ' + n;
  };

  vm[prefix + 'PrevPage'] = function() {
    if (vm[prefix + 'PageIndex'] <= 0) {
      return;
    }
    vm[prefix + 'PageIndex']--;
    vm['update' + cap + 'PagedRows']();
  };

  vm[prefix + 'NextPage'] = function() {
    if (vm[prefix + 'PageIndex'] >= vm[prefix + 'PaginationTotalPages'] - 1) {
      return;
    }
    vm[prefix + 'PageIndex']++;
    vm['update' + cap + 'PagedRows']();
  };

  vm['update' + cap + 'PagedRows']();

  $scope.$watchCollection(function() {
    return getRows();
  }, function() {
    vm['update' + cap + 'PagedRows']();
  });
}



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/labor-distribution-report/modals/labor-cost-breakdown-paging-helper.js